import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Orgstyle } from '../model/orgstyle';
import { environment } from '@src/environments/environment';
import { SessionHelper } from '../../sessionHelper';

@Injectable({
  providedIn: 'root'
})
export class DynamicstyleService {
  constructor(private http:HttpClient) { }

  getOrgstyles(orgId:string){ 
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle[]>(environment.apiUrl+'/organization/'+orgId+'/whitelabel/list',httpOptions);
  }
  getDefaultOrgStyle(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle>('./assets/assets/defaultorgstyle.html',httpOptions)
  }
}
